/**
 * 콘솔 refresh(W6 A7·K-19, CI-07 = 쿠키 + withCredentials) — admin-reseller 와 같은 규칙.
 * inapi 는 refresh 를 httpOnly 쿠키(refreshToken, sameSite strict, path /)에서만 읽고, 그 쿠키는 로그인·2FA 확인·
 * 수단 변경 응답이 심는다. 콘솔(다른 출처) → inapi 라 그 요청들과 갱신 요청에 withCredentials 를 줘야
 * 브라우저가 쿠키를 받고 보낸다. 갱신에는 Authorization 을 싣지 않는다(지금까지 헤더로 보내 갱신이 늘 실패했음).
 * Vue·axios 를 들이지 않는 순수 모듈이라 node --test 로 시험한다(`__tests__/consoleRefresh.test.mjs`).
 */

// refresh 쿠키를 심거나 읽거나 지우는 inapi 경로(setRefreshCookie·로그아웃 clearCookie)
const CREDENTIAL_PATH_RE = /\/auth\/(login|logout|refresh|2fa\/(verify|enroll\/verify|enabled|factors\/[A-Za-z_]+))$/;

/** 이 요청에 쿠키를 주고받아야 하나 */
export const needsCredentials = (url = "") => CREDENTIAL_PATH_RE.test(String(url).split("?")[0]);

/** POST /auth/refresh 요청 설정: 쿠키만(Authorization 없음) */
export const refreshRequestConfig = () => ({ withCredentials: true });

/**
 * 갱신해도 되나 — 로그아웃한 뒤(access 없음)에는 남은 쿠키로 세션을 되살리지 않는다
 * @param accessToken 지금 저장된 access 토큰
 */
export const canRefresh = (accessToken) => !!accessToken;

/** 로그아웃 요청 설정: 쿠키를 지우게 쿠키를 싣고, 401 이어도 갱신·재전송하지 않음(_retry), 알림·본인 확인 창 없음 */
export const logoutRequestConfig = () => ({
  withCredentials: true,
  _retry: true,
  showGlobalLoading: false,
  showErrorNotice: false,
  skipStepUp: true,
});

/** 갱신이 거절됐나(쿠키 없음·만료·1시간 무활동·최대 12시간) */
export const isRefreshRejected = (error) => [401, 403].includes(error?.response?.status);

export const IDLE_LOGOUT_MESSAGE = "1시간 동안 쓰지 않아 로그아웃되었습니다(최대 12시간).";
